import * as tf from '@tensorflow/tfjs';
import {toRaw} from 'vue'

export default class CustomDetection{
    constructor(){
        this.model = null
        this._stopTraining = false;
    }

    async train(labels, data, params = {
            denseUnits: 100,
            epochs: 50,
            learningRate: 0.001,
            batchSize: 16,
            imageSize: 224
        }, callback){

        /* model._metadata.modelName = 'object-detection'
        await this.loadRaw(model)
        return model */
    }

    stopTraining(){
        this._stopTraining = true;
    }

    async save(){
        /* return await save(toRaw(this.model.model), this.model._metadata) */
    }

    async addData(model, dataset){
        /* for(let i = 0; i < dataset.length; i++){
            for(let j = 0; j < dataset[i].length; j++){
                const image = dataset[i][j]
                await model.addExample(i, image)
            }
        } */
    }

    async loadUrl({modelUrl, labels = null}){
        const model = await tf.loadGraphModel(modelUrl)
        await this.loadRaw(model, labels)
    }

    async loadFile({modelFile, weightsFiles, labels = null}){
        const model = await tf.loadGraphModel(tf.io.browserFiles([modelFile, ...weightsFiles]))
        await this.loadRaw(model, labels)
    }

    async loadRaw(model, labels = null){
        const emptyCanvas = document.createElement('canvas');
        emptyCanvas.width = 224;
        emptyCanvas.height = 224;
        this.model = toRaw(model);
        this.labels = labels
        const prediction = await this.predict(emptyCanvas)
    }

    async predict(canvas, threshold = 0.5){
        if (!this.model) return;
        if (!tf.backend) return;
        await tf.setBackend('webgl');
        await tf.ready();

        const tfimg = tf.browser.fromPixels(canvas);
        const tranposed = tfimg.transpose([0,1,2])
        const processedInput = tranposed.expandDims()
        
        /* console.log(this.model) */
        const result = await toRaw(this.model).executeAsync(processedInput);
        if (!result) {
            return
        }
        const prominentDetection = tf.topk(result[0]);
        const justBoxes = await result[1].squeeze();
        const justValues = await prominentDetection.values.squeeze()

        const [maxIndices, scores, boxes] = await Promise.all([
            prominentDetection.indices.data(),
            justValues.array(),
            justBoxes.array(),
        ]);

        const nmsDetections = await tf.image.nonMaxSuppressionWithScoreAsync(
            justBoxes, // shape [numBoxes, 4]
            justValues, // shape [numBoxes]
            10, // Stop making boxes when this number is hit
            0.1 , // Allowed overlap value 0 to 1
            threshold, // Minimum detection score allowed
            0 // 0 is normal NMS, 1 is max Soft-NMS
        );

        const chosen = await nmsDetections.selectedIndices.data();

        const objects = []
        for (let index of chosen) {
            const box = boxes[index]
            const minY = box[0]
            const minX = box[1]
            const maxY = box[2]
            const maxX = box[3]

            objects.push({
                class: maxIndices[index],
                score: (scores[index] * 100).toFixed(2),
                minY: minY,
                minX: minX,
                width: maxX - minX,
                height: maxY - minY
            })
        }

        tf.dispose([
            result[0],
            result[1],
            nmsDetections.selectedIndices,
            nmsDetections.selectedScores,
            prominentDetection.indices,
            prominentDetection.values,
            justBoxes,
            justValues,
            processedInput,
            tranposed,
            tfimg
        ])

        return objects
    }

    async test(){
        const url = "https://models.eduairsz.xyz/ssd-mobilenet-v2/"
        const modelUrl = url + "model.json";
        await this.loadUrl({modelUrl: modelUrl})
        return this
    }
}